module.exports = __webpack_public_path__ + "static/media/2OMB.ea11f985.png";